import axios from "axios";
const buildApiBaseUrl = () => {
  const envUrl = process.env.REACT_APP_API_URL;

  // CRA env vars are baked at build time. A deployed `.env` file will NOT be read.
  // Always rebuild after changing REACT_APP_API_URL.
  const fallback =
    typeof window !== "undefined" ? `${window.location.origin}/api` : "";

  let base = (envUrl || fallback).trim();
  if (!base) return "";

  // Guard against a common misconfiguration where the entire `.env` line is pasted
  // as the value, e.g. `REACT_APP_API_URL=REACT_APP_API_URL=https://example.com`.
  base = base.replace(/^REACT_APP_API_URL\s*=\s*/i, "").trim();

  // Strip trailing slashes
  base = base.replace(/\/+$/, "");

  // REACT_APP_API_URL should be a server base (https://host or https://host/api),
  // not a specific endpoint like https://host/api/clinic.
  if (/\/api\/.+/.test(base)) {
    throw new Error(
      "REACT_APP_API_URL looks like an endpoint (e.g. /api/clinic). Set it to the server base (e.g. https://back.worldbasiclaboratory.com or https://back.worldbasiclaboratory.com/api)."
    );
  }

  // Accept both https://host and https://host/api
  if (base === "/api" || base.endsWith("/api")) return base;
  return `${base}/api`;
};

const API_BASE_URL = buildApiBaseUrl();

if (!API_BASE_URL) {
  throw new Error(
    "Missing REACT_APP_API_URL. Set it in lis-dev/.env (e.g. https://api.your-domain.com/api)."
  );
}

// Create axios instance
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default api;
